import { actions as headlineActions, headlineApiCall } from './headline';
import { actions as industriesActions, industriesApiCall } from './industry';
import { actions as pictureActions, postPicture } from './picture';
import { actions as generalProfileActions, getProfile, destroyProfile } from './profile';
import { actions as nameActions } from './name';
import { actions as locationActions, locationApiCall } from './locations';
import { actions as summaryActions, summaryApiCall } from './summary';
import { actions as pressActions, pressApiCall } from './press';
import { actions as awardsActions, awardsApiCall } from './awards';
import { actions as publicationsActions, publicationsApiCall } from './publications';
import { actions as experienceActions, experienceApiCall } from './experience';
import { actions as endorsementActions, endorsementsApiCall, requestEndorsement } from './endorsements';
import { actions as educationActions, educationApiCall } from './education';
import { actions as certificateActions, certificatesApiCall } from './certificates';
import { actions as formActions, showForm  } from './forms';
import { actions as customUrlActions } from './url';
import { actions as visibilityActions, changeVisibility } from './visibility';
import { actions as guestActions, toggleGuestMode } from './guest';
import { actions as sectorActions, sectorsApiCall } from './sectors';
import { actions as expertiseActions, expertiseApiCall, createExpertise } from './expertise';
import { actions as marketActions, marketsApiCall } from './markets';
import { actions as permissionActions, getUserPermissions } from './permissions';
import { actions as investmentsActions, changeInvestments } from './investments';
import { actions as ratingActions } from './rating';
import { actions as profileCompleteActions, getProfileComplete } from './profile-complete';

export {
    getProfile,
    destroyProfile,
    generalProfileActions,
    industriesActions,
    industriesApiCall,
    headlineActions,
    pictureActions,
    nameActions,
    locationActions,
    summaryActions,
    summaryApiCall,
    experienceActions,
    endorsementActions,
    certificateActions,
    educationActions,
    pressActions,
    awardsActions,
    publicationsActions,
    formActions,
    headlineApiCall,
    locationApiCall,
    experienceApiCall,
    endorsementsApiCall,
    educationApiCall,
    certificatesApiCall,
    pressApiCall,
    awardsApiCall,
    publicationsApiCall,
    showForm,
    customUrlActions,
    visibilityActions,
    changeVisibility,
    requestEndorsement,
    guestActions,
    toggleGuestMode,
    sectorsApiCall,
    expertiseApiCall,
    marketsApiCall,
    sectorActions,
    expertiseActions,
    marketActions,
    postPicture,
    permissionActions,
    getUserPermissions,
    createExpertise,
    investmentsActions,
    changeInvestments,
    ratingActions,
    profileCompleteActions,
    getProfileComplete,
}



// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/index.js